import { Theme } from "@mui/material/styles"

import Base from "./Base"
import Button from "./Button"
import Menu from "./Menu"
import Paper from "./Paper"
import Popover from "./Popover"
import Tooltip from "./Tooltip"
import Select from "./Select"

const Overrides = (theme: Theme) =>
  Object.assign(
    Popover(theme),
    Paper(),
    Base(),
    Tooltip(theme),
    Button(theme),
    Menu(theme),
    Select(theme),
  )

export default Overrides
